// >>> **THE /talk FUNNEL, DRAWN TRUE — HER ORDER, 2026-09-05.** <<<
//
// *"she cannot test the ad herself so this page is her only eyes: one page she watches and sees real
//  humans moving through, live and trustworthy."*
//
// **IT IS HOOKLESS AND TAKES ITS DATA AS A PROP, SO A GATE CAN CALL IT** (R7/R12), and it composes
// NO arithmetic of its own — every count, every share, the sentence and the worst drop are
// `src/talkFunnelBoard.js`'s. A surface that does its own sums is a second answer key (R28/R29), and
// on this page the second answer is the one she would act on.
//
// **IT REPLACES `OwnerFunnelLala`, WHICH IS DELETED.** That board drew the allotment columns and
// printed an apology where two of her five names should have been.
import {
  talkFunnelRows, talkFunnelSentence, talkFunnelWorstDrop, TALK_FUNNEL_COVERAGE_NOTE,
  // HER ORDER, 2026-09-08: the conversion rate by traffic source, side by side, doing the division
  // for her. All of it composed in the law — this file still holds no arithmetic of its own.
  talkFunnelSourceRows, talkFunnelSourceVerdict, TALK_SOURCE_PAINT_NOTE,
} from "../talkFunnelBoard.js";

export type TalkFunnelWindow = {
  saw: number | null;
  painted: number | null;
  left?: number | null;
  signup: number | null;
  reading: number | null;
  spoke: number | null;
  beaconCovers?: boolean;
};
export type TalkFunnelSource = {
  source: string;
  arrivals: number;
  gaveDetails: number;
  reading: number;
  spoke: number;
};
export type TalkFunnelPayload = {
  today: TalkFunnelWindow | null;
  hour: TalkFunnelWindow | null;
  /** `null` is a read that could not be made. `[]` is a real window with no arrivals in it. */
  sources?: TalkFunnelSource[] | null;
  sourceDays?: number;
  sourcePaintBlocker?: string;
  beaconLiveFrom?: string;
  atMs?: number;
};

const short = (n: number) => new Intl.NumberFormat("en-US").format(n);

function Rungs({ board, tag }: { board: TalkFunnelWindow | null; tag: string }) {
  if (!board) return <p className="owner-page__note">These numbers could not be read just now.</p>;
  return (
    <div className="owner-ladder__row" data-talk-funnel-window={tag}>
      {talkFunnelRows(board).map((r) => (
        <div className="owner-ladder__step" key={r.key} data-talk-funnel-step={r.key}>
          {/* A COUNT THAT COULD NOT BE READ IS A DASH AND NEVER A ZERO (R18). */}
          <span className="owner-ladder__n">{r.count === null ? "—" : short(r.count)}</span>
          <span className="owner-ladder__k">{r.label}</span>
          {/* A SHARE PRINTS WHAT IT IS A SHARE OF, so a rung can never be read against the wrong cohort. */}
          <span className="owner-ladder__pct">{r.pct === null ? "" : `${r.pct}% of ${r.of}`}</span>
        </div>
      ))}
      {/* >>> **THE ONES WHO LEFT BEFORE WE COULD TELL, SHOWN RATHER THAN BURIED.** <<< They are out
          of the paint rate on purpose — counting a bounce as a page that failed to load slanders a
          working site, and it is what turned 42 loads and 27 paints into "36% still blank" on this
          board's first live reading. Out of the sum, on the page. */}
      {typeof board.left === "number" && board.left > 0 ? (
        <div className="owner-ladder__step" data-talk-funnel-step="left">
          <span className="owner-ladder__n">{short(board.left)}</span>
          <span className="owner-ladder__k">Left before we could tell</span>
          <span className="owner-ladder__pct">not counted either way</span>
        </div>
      ) : null}
    </div>
  );
}


/**
 * >>> **WHERE THE TRAFFIC COMES FROM, AND WHETHER IT IS REAL — HER ORDER, 2026-09-08.** <<<
 *
 * *"A source converting at 0.05% while direct converts at 50% flags itself on the screen she
 *  actually looks at. This is the instrument she was missing."*
 *
 * **IT WAS MISSING FOR FIVE DAYS AND IT COST HER FIVE DAYS.** The board showed signups falling
 * 251 to 14 on flat traffic, every rung above said the page was fine, and it read as a broken
 * funnel. It was not one: TikTok was sending 7,751 arrivals a day and converting 4 of them while
 * direct converted a third of everyone it sent, on the same page, in the same hours.
 *
 * **THE FLAGGING IS THE FEATURE.** A table of rates is still a table she has to divide in her head,
 * and nobody did that division for five days. The sentence does it.
 */
function SourceSplit({ sources, days }: { sources: TalkFunnelSource[] | null | undefined; days: number }) {
  // THREE STATES (R18): in flight, a read that could not be made, and a real empty window.
  if (sources === undefined) return null;
  if (sources === null) {
    return <p className="owner-page__note">Where the traffic came from could not be read just now.</p>;
  }
  const rows = talkFunnelSourceRows(sources);
  const verdict = talkFunnelSourceVerdict(sources);
  if (!rows.length) {
    return <p className="owner-page__note">{`No arrivals landed on the page in the last ${days} days.`}</p>;
  }
  return (
    <div data-talk-funnel-split="">
      {/* THE ACCUSATION FIRST, because it is the thing she is here to learn. */}
      {verdict ? (
        <p className="owner-ladder__headline" data-talk-funnel-verdict={verdict.worst}>{verdict.sentence}</p>
      ) : null}
      <table className="owner-table" data-talk-funnel-sources-table="">
        <thead>
          <tr>
            <th>Where from</th><th>Arrived</th><th>Gave her details</th>
            <th>Converted</th><th>Got a reading</th><th>Spoke to Lala</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.source} data-source={r.source} data-judged={r.judged ? "yes" : "no"}>
              <td>{r.source}</td>
              <td>{short(r.arrivals)}</td>
              <td>{short(r.gaveDetails)}</td>
              {/* A RATE OVER TOO LITTLE IS NOT 0% — it says why, so a quiet source is never
                  mistaken for a dead one (R141). */}
              <td title={r.why}>{r.pct === null ? "—" : `${r.pct}%`}</td>
              <td>{short(r.reading)}</td>
              <td>{short(r.spoke)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function OwnerTalkFunnel({ board }: { board: TalkFunnelPayload | null | undefined }) {
  // >>> THREE STATES, NEVER TWO (R18/R65). <<< `undefined` is still in flight and holds still.
  // `null` is a read that ARRIVED AND COULD NOT BE MADE — drawing that as zeroes tells her the ad
  // reached nobody on a day the database refused a query.
  if (board === undefined) return null;
  if (board === null) {
    return (
      <section className="owner-ladder" data-talk-funnel="unread">
        <h3 className="owner-detail__sub">The Ask Lala funnel</h3>
        <p className="owner-page__note">These numbers could not be read just now.</p>
      </section>
    );
  }

  const sentence = talkFunnelSentence(board.today || {});
  const worst = talkFunnelWorstDrop(board.today || {});

  return (
    <section className="owner-ladder" data-talk-funnel="read">
      <h3 className="owner-detail__sub">The Ask Lala funnel</h3>

      {/* >>> HER CLAUSE 4 — THE PLAIN SENTENCE AT THE TOP, IN REAL WORDS. <<< Nothing where the
          reader cannot stand behind a number: this is the line she would quote to somebody. */}
      {sentence ? <p className="owner-ladder__headline">{sentence}</p> : null}

      <h4 className="owner-page__note">Today</h4>
      <Rungs board={board.today} tag="today" />

      <h4 className="owner-page__note">The last hour</h4>
      <Rungs board={board.hour} tag="hour" />

      {/* >>> WHERE THEY STOP, WHICH IS WHAT SHE ASKED THIS PAGE TO SHOW HER. <<< Nothing on a chain
          too thin to have a worst step — on a handful of arrivals every drop is large and pointing
          at one of them is noise wearing the clothes of a finding (R141). */}
      {worst ? (
        <p className="owner-page__note" data-talk-funnel-drop={worst.to}>
          {`Biggest fall today: ${worst.lost}% are lost between ${worst.from} and ${worst.to}.`}
        </p>
      ) : null}

      {/* >>> WHERE THE TRAFFIC CAME FROM, AND WHETHER IT IS REAL. <<< Read over a WEEK rather
          than today: direct sends 15-40 arrivals a day and would sit under the judging floor every
          morning, which is how a source that converts at 50% would come to look unmeasurable. */}
      <h4 className="owner-page__note">{`Where they came from — last ${board.sourceDays ?? 7} days`}</h4>
      <SourceSplit sources={board.sources} days={board.sourceDays ?? 7} />
      <p className="owner-page__note">{TALK_SOURCE_PAINT_NOTE}</p>

      {/* >>> WHAT EACH COLUMN IS READ FROM, PRINTED. <<< Her clause: one reader shared with the
          ledger, so the board can never disagree with reality again. A column whose source is not
          written down is a column somebody re-derives differently later, which is how the 2.7x
          over-count and the leads-versus-visits lie both happened. */}
      <ul className="owner-page__note" data-talk-funnel-sources="">
        {talkFunnelRows(board.today || {}).map((r) => (
          <li key={r.key}>{`${r.label} — ${r.source}`}</li>
        ))}
      </ul>

      {/* >>> AND WHAT IS NOT COUNTED YET IS PRINTED RATHER THAN LEFT AS AN ABSENCE (R17/R160). <<< */}
      <p className="owner-page__note">{TALK_FUNNEL_COVERAGE_NOTE}</p>
    </section>
  );
}
